export type TimelineRoundStatus = 'CANCELLED' | 'FAILED' | 'PENDING' | 'SUCCEEDED' | 'UNAVAILABLE'

/** 与脊柱分段、状态节点一致的主题变量色 */
export function timelineStemCss(
  deferring: boolean,
  awaitingGen: boolean,
  status: TimelineRoundStatus,
): string {
  if (deferring || awaitingGen) return 'var(--timeline-rail-warn)'
  if (status === 'FAILED') return 'var(--timeline-rail-danger)'
  if (status === 'CANCELLED') return 'var(--timeline-rail-cancelled)'
  if (status === 'UNAVAILABLE') return 'var(--timeline-rail-muted)'
  if (status === 'PENDING') return 'var(--timeline-rail-warn)'
  return 'var(--timeline-rail-success)'
}

export function timelineStemSegmentBackground(from: string, to: string): string {
  const blend = 'var(--glyphicai-tl-stem-blend, min(7.5rem, 45%))'
  const blendMid = 'var(--glyphicai-tl-stem-blend-mid, min(4rem, 22%))'
  const start = `max(0%, calc(100% - ${blend}))`
  const mid = `max(0%, calc(100% - ${blendMid}))`
  return [
    `linear-gradient(180deg,`,
    `${from} 0%,`,
    `${from} ${start},`,
    `color-mix(in srgb, ${from} 52%, ${to} 48%) ${mid},`,
    `${to} 100%)`,
  ].join(' ')
}
